module.exports = __webpack_public_path__ + "img/action-6.28155eb8.svg";